import { MenuButton } from '@szhsin/react-menu';
import styled from 'styled-components';

export const MenuBtn = styled(MenuButton)`
  background-color: transparent;
  border: none;
  height: 2rem;
  width: 2rem;
`;
